<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="600px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-link-variant-plus
          </v-icon> Link Partner
        </h2>
        <v-card-text>
          <v-form>
            <p class="p-style">
              Please choose the Partner Company you want to link with this organization.
            </p>
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                cols="12"
                md="10"
              >
                <v-select
                  v-model="orgLinkingPartner"
                  menu-props="auto"
                  :items="partnersList"
                  item-value="id"
                  item-text="name"
                  label="Our Partners"
                  dense
                  outlined
                  single-line
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false;"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="linkOrganizationPartner()"
          >
            Link
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'LinkOrganizationPartners',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        orgLinkingPartner: '',
      };
    },
    computed: {
      partnersList () {
        return this.$store.getters['partners/getPartnersList'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      await this.getPartnersList();
    },
    methods: {
      async getPartnersList () {
        this.loading = true;
        await this.$store.dispatch('partners/fetchPartnersList');
        this.loading = false;
      },
      async linkOrganizationPartner () {
        this.loading = true;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/linkOrganizationPartner', {
          organizationId: organizationlId,
          partnerId: this.orgLinkingPartner,
        })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Partner linked successfully against this organization',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.$emit('partner-linked');
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
.p-style {
  font-size: 20px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #546E7A;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 35px;
}
</style>
